import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import HorizontalScroll from 'react-horizontal-scrolling'
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Grid,
  LinearProgress,
  Divider,
  Typography,
  makeStyles,
  colors,
  CardMedia,
  Button,
  Link
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ReactPlayer from 'react-player'
import RehabPhases from "../rehabPhases";
import { useSelector, useDispatch } from "react-redux"
import Recovery_phases from '../recoveryPhases';
import WeeklyGoal from './WeeklyGoal';
import TreatmentSessionPlayer from "../../treatmentSession/treatmentSessionPlayer";
import WelcomeScreenTreatmentSession from '../../treatmentSession/welcomeScreen';
import WelcomeScreenPreparationText from "../../treatmentSession/welcomeScreen2";

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 16,
    // semi-transparent white background
    background: "#f7faff",
    // don't stretch to fill parent; size to content
    height: 'auto',
    alignSelf: 'flex-start',
    display: 'block',
  },
  cardHeader: {
    alignItems: 'center',
  },
  avatar: {
    backgroundColor: '#6a8caf',
    height: 'clamp(20px, 2.2vw, 36px)',
    width: 'clamp(20px, 2.2vw, 36px)',
  },
  cardHeaderTitle: {
    color: "#002D55",
    fontWeight: "bold",
    fontSize: 'clamp(15px, 1.4vw, 22px)',
  },
}));

const RehabPlanMainComponent = (props) => {
  const className = props.className
  
  const classes = useStyles();

  const { innerWidth: width, innerHeight: height } = window;

  const [token, _] = useState(useSelector(state => state.auth.token))
  const [exercises, setExercises] = useState([])
  const { drawerOpen, setDrawerOpen, treatmentId } = props;

  const simpleFormatter = (text, len) => {
    var i = 0;
    for(i = 0; i < text.length; i = i+len){
      if (i != 0) {
        const subString = text.slice(0, i).split("").reverse().join(""); // abc d -> d cba
        const splitIndex = subString.length - subString.indexOf(' ');
        text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
      }
    }
    return text;
  }
  
 // const fetchExercises = async () => {
 //   const response = await fetch("https://api.virtus-one.com/treatment/exercises/all", {
 //     headers: {
 //       "Authorization": `Token ${token}`
 //     },
 //     method: "GET",
 //   });
//
 //   if (response.ok) {
 //     const data = await response.json();
 //     console.log(data)
 //     setExercises(data[0]["exercises"])
//
 //   } else {
 //     alert("ERROR")
 //   }
 // }
//
 // useEffect(() => {
 //   fetchExercises()
 // }, [])

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader
        avatar={<Avatar className={classes.avatar}><DashboardIcon style={{ color: '#fff', fontSize: 'clamp(14px, 1.4vw, 22px)' }} /></Avatar>}
        title={<span className={classes.cardHeaderTitle}>Physiotherapy Plan</span>}
        className={classes.cardHeader}
        style={{ marginBottom: 0, marginTop: 0, padding: 10 }}
        gutterBottom
      />
      <Divider style={{borderBottom: "2px solid #fb741a", marginBottom: 5}}/>
      <CardContent>
        <Grid
          container
          justify="center"
          spacing={3}
        >
        
          <Grid container item xs={12} direction="row" justify="center" alignItems="center" style={{ width: '100%', marginLeft: 0, marginRight: 0, paddingLeft: 8, paddingRight: 2, paddingTop: 4 }}>
              <Grid item xs={12}>
                <TreatmentSessionPlayer 
                  drawerOpen={drawerOpen} 
                  setDrawerOpen={setDrawerOpen} 
                  treatmentId={treatmentId}
                />
              </Grid>
          </Grid>
            
        </Grid>
      </CardContent>
    </Card>
  );
};

RehabPlanMainComponent.propTypes = {
  className: PropTypes.string
};

export default RehabPlanMainComponent;